export const TRASH_LIST_GENERIC_ACTIVITY_LIST_SORT = 'TRASH_LIST_GENERIC_ACTIVITY_LIST_SORT';

export const TRASH_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE = 'TRASH_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE';
